// filterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {},
    filterOptions: {}
};

const filterSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setFilters: (state, action) => {
            // Completely replace the filters instead of merging
            state.filters = action.payload;
        },
        clearFilters: (state) => {
            state.filters = {};
        },
        removeFilter: (state, action) => {
            const { key, value } = action.payload;
            if (state.filters[key]) {
                state.filters[key] = state.filters[key].filter(v => v !== value);
                if (state.filters[key].length === 0) {
                    delete state.filters[key];
                }
            }
        },
        // Only stores options the first time — never overwrites once set
        setFilterOptions: (state, action) => {
            if (Object.keys(state.filterOptions).length === 0) {
                state.filterOptions = action.payload;
            }
        },
        clearFilterOptions: (state) => {
            state.filterOptions = {};
        }
    }
});

export const { setFilters, clearFilters, removeFilter, setFilterOptions, clearFilterOptions } = filterSlice.actions;
export const selectFilters = (state) => state.filters.filters;
export const selectFilterOptions = (state) => state.filters.filterOptions;
export default filterSlice.reducer;
